import { serviceContext$ } from '../../bus';
import { SetUpServiceData } from '../basket/types';
import { clone } from '../clone';
import { restoreAdditionalServiceFromStorageState } from './restoreAdditionalServiceFromStorageState';

/**
 * restoreAdditionalServiceFromStorageSubscriber содержит реализацию подписчика на
 * subject восстановления, который выполняется только один раз в случае
 * если ни один из вариантов восстановления не валиден или один из валиден.
 * Запускает активный способ восстановления. Снимает флаг восстановления,
 * если восстановленивать нечего.
 *
 * @param restoreState
 * @param langID
 * @param currencyID
 */
export const restoreAdditionalServiceFromStorageSubscriber = async (
  restoreState: any,
  langID: string,
  currencyID: string
) => {
  const state = clone(serviceContext$.getValue());

  const setUpServiceDataIndex = restoreState.findIndex(
    (service: SetUpServiceData) => !!service?.IsSetupService
  );

  if (setUpServiceDataIndex === -1) {
    serviceContext$.next({
      ...state,
      IsRestoringState: false,
    });
    return;
  }

  const otherServices = restoreState.slice();
  otherServices.splice(setUpServiceDataIndex, 1);

  restoreAdditionalServiceFromStorageState(
    restoreState[setUpServiceDataIndex],
    otherServices,
    langID,
    currencyID
  );
};
